<template>
	<div id="progress-indicator">
		<span v-for="e in max" :key="'step' + e" class="px-1">
			<img src="@/assets/lollipop.png" alt="" :class="{ unlocked: e > step }" />
		</span>
		<div class="message is-size-7 px-2 py-1 is-bg-primary">{{ message }}</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";

	export default defineComponent({
		props: {
			max: Number,
			step: {
				type: Number,
				default: 0,
			},
			message: String,
		},
	});
</script>
<style lang="stylus" scoped>
	#progress-indicator {
		position: relative;
	}

	#progress-indicator:hover .message {
		display: inline-block;
	}

	#progress-indicator img {
		width: 24px;

		@media screen and (min-width: 500px) {
			width: 36px;
		}
	}

	.unlocked {
		filter: grayscale(1);
	}

	.message {
		display: none;
		position: absolute;
        top: -48px;
		left: 0;
	}
</style>